import { connect } from "react-redux";
import { push } from "connected-react-router";

import SitesPage from "../components/Sites/SitesPage";

import { linkSite,  retrieveSites, updateSiteUrl } from "shared-frontend/redux/actions/sites";
import { linkSiteModalOpen } from "../redux/actions/sites";
import { onSearchQueryChange } from "../redux/actions/search";
import { getSearchQuery } from "shared-frontend/redux/selectors/entities/search";
import { getViewableSites } from "shared-frontend/redux/selectors/entities/sites";
import { getAllProvisionerData } from "shared-frontend/redux/actions/provisionerData";
import { getProvisionersById } from "shared-frontend/redux/selectors/entities/provisioners";


export const mapStateToProps = ( state ) => {
	let sites = getViewableSites( state );

	const query = getSearchQuery( state );
	if ( query.length > 0 ) {
		sites = sites.filter( ( site ) => {
			return site.siteName.includes( query ) || site.url.includes( query );
		} );
	}

	// Mapped rather than assigned in place: `getViewableSites` is memoised, so writing onto its
	// output would mutate the objects every other consumer of that selector holds.
	const provisionersById = getProvisionersById( state );
	sites = sites.map( site => ( {
		...site,
		provisioner: provisionersById[ site.provisionerId ],
	} ) );

	const modalOpen      = state.ui.sites.addSiteModalOpen;
	const errorFound     = state.ui.sites.linkSiteFailed;
	const linkError      = state.ui.sites.linkSiteError;
	const linkSuccess    = state.ui.sites.linkSiteSuccess;
	const linkingSiteUrl = state.ui.sites.linkingSiteUrl;
	const loadingSites   = ! state.ui.sites.sitesRetrieved;

	return {
		sites,
		modalOpen,
		errorFound,
		linkError: linkError,
		linkSuccess: linkSuccess,
		linkingSiteUrl,
		query,
		loadingSites,
	};
};

export const mapDispatchToProps = ( dispatch ) => {
	dispatch( retrieveSites() );
	dispatch( getAllProvisionerData() );

	return {
		addSite: ( url ) => {
			dispatch( linkSiteModalOpen() );
			dispatch( updateSiteUrl( url ) );
		},
		onSearchChange: ( query ) => {
			dispatch( onSearchQueryChange( query ) );
		},
		submitAddSite: ( url, type ) => {
			dispatch( linkSite( url, type, ( json ) => {
				if ( json && json.site && json.site.id ) {
					dispatch( push( `/sites/${ json.site.id }` ) );
				}
			} ) );
		},
		onManage: ( siteId ) => {
			dispatch( push( "/sites/" + siteId ) );
		},
	};
};

export const mergeProps = ( stateProps, dispatchProps, ownProps ) => {
	let url = stateProps.linkingSiteUrl;

	if ( stateProps.linkingSiteUrl.length === 0 ) {
		url = stateProps.query;
	}


	const addSite = () => {
		dispatchProps.addSite( url );
	};

	return Object.assign( {}, ownProps, stateProps, dispatchProps, { addSite } );
};

const SitesPageContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps,
)( SitesPage );

export { SitesPageContainer };
